<template>
    <div class="text-center">
        <div v-if="dialog == true" class="modal fade show" id="Modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" style="display: block; padding-right: 12px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="ModalLabel">{{ actionType }} regla de carga de caché</h5>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                            <form class="container pl-50">
                            <div>
                                <div class="mt-2 p-0 pb-3 alert alert-warning">
                                    <div class="mt-3">
                                        <b>Reglas de Apertura</b>: Cerrar antes un nivel superior
                                    </div>
                                    <div class="mt-3">
                                        Ej: NO abrir Madrid sin cerrar antes España
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Conector</b></label>
                                    <div class="mt-3">
                                        <select v-model="name" class="border w-100 p-2">
                                        <option v-for="option in nameConnectors" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Tipo Tarifa</b></label>
                                    <div class="mt-3">
                                        <select v-model="rate_type" class="border w-100 p-2">
                                        <option v-for="option in rateTypes" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Mercado cliente</b></label>
                                    <div class="mt-3">
                                        <select v-model="marketGeoUnitName" class="border w-100 p-2">
                                        <option v-for="option in markets" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Pais Destino</b></label>
                                    <div class="mt-3">
                                        <select v-model="destination" class="border w-100 p-2">
                                        <option v-for="option in destinations" v-bind:value="option.value" :key="option.value">
                                          {{option.text}}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                  <label class="text-left w-100" style="text-align: left;" ><b>Location</b></label>
                                  <div class="mt-3" v-if="dataIsLoaded">
                                    <select v-model="geounitLocationID" class="border w-100 p-2">
                                      <option v-for="option in locations" v-bind:value="option.value" :key="option.value">
                                        {{ option.text }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class="mt=3" v-else>Seleccione un pais.</div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Abierto / Cerrado</b></label>
                                    <div class="mt-3">
                                        <select v-model="opened" class="border w-100 p-2">
                                        <option v-for="option in openedClosed" v-bind:value="option.value" :key="option.value">
                                            {{ option.text }}
                                        </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3" >
                                    <label class="text-left w-100" style="text-align: left;"><b>Comentario</b></label>
                                    <div class="mt-3">
                                        <textarea class="border w-100 p-2" v-model="comments" placeholder="Escribe un comentario..."></textarea>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Comienzo</b></label>
                                    <div class="mt-3">
                                        <input class="border w-100 p-2" v-model="dateStart" type="date">
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <label class="text-left w-100" style="text-align: left;"><b>Fin</b></label>
                                    <div class="mt-3">
                                        <input class="border w-100 p-2" v-model="dateEnd" type="date">
                                    </div>
                                </div>

                                
                            </div>
                            </form>
                        </slot>
                    </div>
                    <span v-if="saveResponse != null">
                        <div class="dropdown-divider"></div>
                        <span v-for="singleError in saveResponse" :key="singleError"> 
                            <div class="alert alert-success" role="alert" v-if="singleError==='Ok'">Campo insertado / editado con éxito</div>
                            <div class="alert alert-danger" role="alert"  v-else>
                                <p> {{singleError}} </p>
                            </div>
                        </span>
                    </span>
                    <div class="dropdown-divider"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-black" style="background-color: #f5f5f5; border: 1px solid gray;" data-dismiss="modal" @click="close()">Cerrar</button>
                        <button type="button" class="btn btn-success text-white mx-2" style="border: 1px solid gray;" @click="save()">{{ actionType }}</button>
                    </div>
                </div>
            </div>
        </div>
        <h1 class="py-4">Reglas de carga de cache</h1>
        <div class="col-md-12 py-4">
            <button type="button" @click="insert()" class="btn btn-primary text-white" data-toggle="modal" data-target="#newmodal">Añadir regla</button>
            <button type="button" @click="csvExport()" class="btn btn-success text-white mx-2">Exportar a Excel</button>
        </div>
        <select v-model="selected" class="mx-auto m-4 block table table-striped table-bordered table-condensed w-75" id="itemsPerPage" @change="changeItemsPerPage()">
            <option v-for="option in selectItems" v-bind:value="option.value" :key="option.value">
                {{ option.text }}
            </option>
        </select>
        <div class="w-75 text-right container py-4" style="text-align: right;">
            <button type="button" @click="changeExtendedView" class="btn btn-primary text-white">{{ extendedViewText }}</button>
        </div>
        <span v-if="dropResponse != null">
            <span v-for="singleError in dropResponse" :key="singleError"> 
                <div class="alert alert-success" role="alert" v-if="singleError==='Ok'">Campo eliminado con éxito</div>
                <div class="alert alert-danger" role="alert" show variant="danger" v-else>
                    <p> {{singleError}} </p>
                </div>
            </span>
        </span>
        <v-table :data="data" :filters="filters" selectionMode="multiple"
        :currentPage.sync="currentPage" :pageSize="pageSize" @totalPagesChanged="totalPages = $event" @selectionChanged="selectedRows = $event" class="border mx-auto block text-center table table-striped table-bordered table-condensed w-75" :rows-per-page-items="opts">
            <thead slot="head" class="border border-secondary p-2">
                <tr>
                    <td class="border p-2"><input class="form-control" v-model="filters.name.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.rate_type.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.marketGeoUnitName.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.destination.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.geounitLocationID.value"/></td>
                    <td class="border p-2"><input class="form-control" v-model="filters.opened.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.user.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.created_at.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.updated_at.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.comments.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.dateStart.value"/></td>
                    <td v-if="extendedView === true" class="border p-2"><input class="form-control" v-model="filters.dateEnd.value"/></td>
                    <td class="border p-2"></td>
                </tr>
                <tr>
                    <v-th sortKey="name" class="border p-2 bg-info text-white" style="cursor: pointer;">Conector</v-th>
                    <v-th sortKey="rate_type" class="border p-2 bg-info text-white" style="cursor: pointer;">Tipo Tarifa</v-th>
                    <v-th sortKey="marketGeoUnitName" class="border p-2 bg-info text-white" style="cursor: pointer;">Mercado cliente</v-th>
                    <v-th sortKey="destination" class="border p-2 bg-info text-white" style="cursor: pointer;">Pais Destino</v-th>
                    <v-th sortKey="geounitLocationID" class="border p-2 bg-info text-white" style="cursor: pointer;">Location</v-th>
                    <v-th sortKey="opened" class="border p-2 bg-info text-white" style="cursor: pointer;">Abierto</v-th>
                    <v-th v-if="extendedView === true" sortKey="user" class="border p-2 bg-info text-white" style="cursor: pointer;">Usuario</v-th>
                    <v-th v-if="extendedView === true" sortKey="created_at" class="border p-2 bg-info text-white" style="cursor: pointer;">Creado</v-th>
                    <v-th v-if="extendedView === true" sortKey="updated_at" class="border p-2 bg-info text-white" style="cursor: pointer;">Actualizado</v-th>
                    <v-th v-if="extendedView === true" sortKey="comments" class="border p-2 bg-info text-white" style="cursor: pointer;">Comentario</v-th>
                    <v-th v-if="extendedView === true" sortKey="date_start" class="border p-2 bg-info text-white" style="cursor: pointer;">Comienzo</v-th>
                    <v-th v-if="extendedView === true" sortKey="date_end" class="border p-2 bg-info text-white" style="cursor: pointer;">Fin</v-th>
                    <th class="border p-2 bg-info text-white" style="min-width: 100px;">Acciones</th>
                </tr>
            </thead>
            <tbody slot="body" slot-scope="{displayData}">
                <tr v-for="row in displayData" :key="row.id" class="border p-2">
                    <td class="border p-2">{{ row.name }}</td>
                    <td class="border p-2">{{ row.rate_type }}</td>
                    <td class="border p-2">{{ row.marketGeoUnitName }}</td>
                    <td class="border p-2">{{ row.destination }}</td>
                    <td class="border p-2">{{ row.locationName }}</td>
                    <td class="border p-2">{{ row.opened }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.user }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.created_at }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.updated_at }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.comments }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.date_start }}</td>
                    <td v-if="extendedView === true" class="border p-2">{{ row.date_end }}</td>
                    <td class="border p-2">
                        <button @click="edit(row.id)" :data-id="row.id" class="act-edit" style="text-decoration: none; min-width: initial; width: 30px">
                            <span class="button__content"><span aria-hidden="true" class="v-icon notranslate theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path></svg></span></span>
                        </button >
                        <span class="mx-2"></span>
                        <button @click="drop(row.id)" :data-id="row.id" class="act-delete" style="text-decoration: none; min-width: initial; width: 30px">
                            <span class="text-dark" style="font-size: 20px;">
                                <span class="button__content"><span class="text-dark" style="font-size: 20px;"><span aria-hidden="true" class="v-icon notranslate theme--light"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path></svg></span></span></span>
                            </span>
                        </button >
                    </td>
                </tr>
            </tbody>
        </v-table>
        <span class="border mx-auto block text-center table table-striped table-bordered table-condensed w-75" >
            <smart-pagination
                v-model="currentPage"
                class="my-4"
                :currentPage.sync="currentPage"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @totalPagesChanged="totalPages = $event"
                :maxPageLinks="10"
                :boundaryLinks="true"
            ></smart-pagination>
        </span>     
    </div>
</template>
<script>
import VTable from './VTable.vue'
import VTh from './VTh.vue'
import SmartPagination from './SmartPagination.vue'

export default {
  name: 'DataTable',
  components: {
    VTable, VTh, SmartPagination
  },
  data: () => ({
    data: [],
        dataIsLoaded: false,
        dataFiltered: [],
        filters: {
            name: { value: '', keys: ['name'] },
            rate_type: { value: '', keys: ['rate_type'] },
            marketGeoUnitName: { value: '', keys: ['marketGeoUnitName'] },
            destination: { value: '', keys: ['destination'] },
            geounitLocationID: { value: '', keys: ['geounitLocationID'] },
            opened: { value: '', keys: ['opened'] },
            created_at: { value: '', keys: ['created_at'] },
            updated_at: { value: '', keys: ['updated_at'] },
            comments: { value: '', keys: ['comments'] },
            user: { value: '', keys: ['user'] },
            dateStart: { value: '', keys: ['date_start'] },
            dateEnd: { value: '', keys: ['date_end'] }
        },
        order: 'asc',
        currentPage: 1,
        totalPages: 0,
        opts: [15, 30, 50, 100, -1],
        selectItems: [   
            {"value": null, "text": "Elementos por página", disabled: true},
            {"value": "15", "text": "15"},
            {"value": "30", "text": "30"},
            {"value": "50", "text": "50"},
            {"value": "100", "text": "100"},
            {"value": "-1", "text": "Todos"}
        ],
        selectedRows: [],
        selected: null,
        nameConnectors: [],
        markets: [],
        destinations: [],
        locations: [],
        pageSize: 15,
        dialog: false,
        name: null,
        rate_type: null,
        marketGeoUnitName: null,
        destination: null,
        geounitLocationID: null,
        opened: null,
        comments: null,
        dateStart: null,
        dateEnd: null,
        extendedView: false,
        extendedViewText: 'Vista extendida',
        actionType: '',
        saveResponse: null,
        dropResponse: null,
        cacheConnectorRuleId: null,
        rateTypes: [   
            {"value": null, "text": "Seleccione una Tarifa", disabled: true},
            {"value": "B2B", "text": "B2B"},
            {"value": "PUBLIC", "text": "B2C"},
            {"value": "OPAQUE", "text": "Opacas"},
            {"value": "TODOS", "text": "Todos"}
        ],
        openedClosed: [   
            {"value": null, "text": "Seleccione un tipo", disabled: true},
            {"value": "0", "text": "Cerrado"},
            {"value": "1", "text": "Abierto"},
        ],
  }),
  mounted () {
        fetch(`${process.env.VUE_APP_API_BASE_PATH}getcacheconnectorsrules`)
        .then(res => res.json())
        .then(data => {this.data = data.data; })
        .catch(err => console.log(err.message));

        fetch(`${process.env.VUE_APP_API_BASE_PATH}getcountries`)
        .then(res => res.json())
        .then(data => {[this.markets, this.destinations] = [data.data, data.data]})
        .catch(err => console.log(err.message));

        fetch(`${process.env.VUE_APP_API_BASE_PATH}getconnectors`)
        .then(res => res.json())
        .then(data => {this.nameConnectors = data.data; })
        .catch(err => console.log(err.message));
    },
  watch: {
    destination: function () {
      this.getLocations();
    }
  },
  methods: {
        csvExport() {
            var arrData = this.getDataFiltered();
            
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
            Object.keys(arrData[0]).join(";"),
            ...arrData.map(item => Object.values(item).join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");
            
            const csvData = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", csvData);
            link.setAttribute("download", "export.csv");
            link.click();
            
        },
        changeItemsPerPage (){
            if (this.selected == null){
                this.pageSize = 15;    
            }else{
                this.pageSize = this.selected;
            }
        },
        save() {
            fetch(`${process.env.VUE_APP_API_BASE_PATH}addNewRule`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    connector: this.name,
                    rate_type: this.rate_type,
                    marketGeoUnitName: this.marketGeoUnitName,
                    destination: this.destination,
                    opened: this.opened,
                    comments: this.comments,
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    cacheConnectorRuleId: this.cacheConnectorRuleId,
                    geounitLocationID: this.geounitLocationID,
                })
            })
            .then((response) => response.json())
            .then(data => { this.saveResponse = data.data})
            .catch(err => console.log(err.message));
            
        },
        insert() {
            this.actionType = 'Insertar';
            this.dialog = true;
        },
        edit(ruleID) {
            this.actionType = 'Editar';
            var arrData = this.searchExactData({ id: ruleID});
            this.cacheConnectorRuleId = ruleID;
            this.name = arrData[0].connector_id;
            this.rate_type = arrData[0].rate_type_id;
            this.marketGeoUnitName = arrData[0].geounit_market_id;
            this.destination = arrData[0].geounit_destination_id;
            this.opened = arrData[0].opened_id;
            this.comments = arrData[0].comments;
            this.dateStart = arrData[0].date_start;
            this.dateEnd = arrData[0].date_end;
            this.geounitLocationID = arrData[0].geounit_location_id;
            
            this.dialog = true;
            this.dataIsLoaded = true;
        },
        drop(ruleID) {
            this.cacheConnectorRuleId = ruleID;
            
            fetch(`${process.env.VUE_APP_API_BASE_PATH}dropRule`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cacheConnectorRuleId: this.cacheConnectorRuleId
                })
            })
            .then((response) => response.json())
            .then(data => { this.dropResponse = data.data})
            .then(setTimeout(function(){ location.reload(); }, 1500))
            .catch(err => console.log(err.message));

        },
        searchFilteredData(filters) {
            return this.data.filter(function (o) {
                return Object.keys(filters).every(function (k) {
                    return o[k].toLowerCase().split(',').some(function (v) {
                        return v.toLowerCase().includes(filters[k].toLowerCase());
                    });
                });
            });
        },
        getDataFiltered () {
            var name = this.filters.name.value ? this.filters.name.value : '';
            var rate_type = this.filters.rate_type.value ? this.filters.rate_type.value : '';
            var marketGeoUnitName = this.filters.marketGeoUnitName.value ? this.filters.marketGeoUnitName.value : '';
            var destination = this.filters.destination.value ? this.filters.destination.value : '';
            var opened = this.filters.opened.value ? this.filters.opened.value : '';
            return this.searchFilteredData({ name: name, rate_type: rate_type, marketGeoUnitName: marketGeoUnitName, destination:  destination, opened: opened});
        },
        searchExactData(filters) {
            return this.data.filter(function (o) {
                return Object.keys(filters).every(function (k) {
                    return o[k].toLowerCase().split(',').some(function (v) {
                        return v.toLowerCase() == filters[k].toLowerCase();
                    });
                });
            });
        },
        changeExtendedView () {
            if (this.extendedView){
                this.extendedView = false;
                this.extendedViewText = 'Vista extendida';
            }else{
                this.extendedView = true;
                this.extendedViewText = 'Vista compacta';
            }
            
        },
        close () {
            this.dialog = false;
            if (this.saveResponse != null){
                location.reload();
            }
        },
        getLocations() {

          this.dataIsLoaded = false;
          fetch(`${process.env.VUE_APP_API_BASE_PATH}getLocations`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              countryId: this.destination
            })
          })
          .then((response) => response.json())
          .then(data => { this.locations = [...data.data] })
          .catch(err => console.log(err.message));

          this.dataIsLoaded = true;
        }
    },
}
</script>
<style scope>
ul.pagination{
    align-items: center;
    display: inline-flex;
    list-style-type: none;
    justify-content: center;
    margin: 0;
    max-width: 100%;
    width: 100%;
}
select{
    padding: .5rem !important;
    width: 100%;
    border: 1px solid #dee2e6 !important;
    background-color: transparent;
    border-style: none;
    text-transform: none;
    font-size: 18px;
    cursor: pointer;
}
#itemsPerPage{
    border: none !important;
    border-bottom: 1px solid gray !important;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
}
.modal.show .modal-dialog {
    -webkit-transform: translate(0,0);
    transform: translate(0,0);
}
.modal.fade .modal-dialog {
    transition: -webkit-transform .3s ease-out;
    transition: transform .3s ease-out;
    transition: transform .3s ease-out,-webkit-transform .3s ease-out;
}
.modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
    margin-right: auto;
    margin-left: auto;
}
*, ::after, ::before {
    box-sizing: border-box;
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.fade.show {
    opacity: 1;
}
.modal {
    z-index: 1072;
}
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    outline: 0;
}
.fade {
    transition: opacity .15s linear;
}

</style>